

export interface ICollection extends Components.Schemas.ICollection { 
  _id: string
  title: string
  fixed_position?: boolean // «Не перемешивать»: не участвует в ротации
  end_date?: string | null // «Дата окончания»: после неё подборка уходит в архив
  createdAt?: string
}
export interface IUpdateCollection extends Components.Schemas.IUpdateCollection { }
export interface ICreateCollection extends Components.Schemas.ICreateCollection { }
export interface ICollectionQueryRequest extends Components.Schemas.ICollectionQueryRequest { }
export interface IPopulatedCollection extends Components.Schemas.IPopulatedCollection {
  fixed_position?: boolean
  end_date?: string | null
}

export enum ECollectionStatus {
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED',
}
